import { createSlice } from '@reduxjs/toolkit'

const openNavigation = window.localStorage.getItem('openNavigation') === 'false' ? false : window.innerWidth > 1535 
const openSidebar = window.localStorage.getItem('openSidebar') === 'false' ? false : window.innerWidth > 900 
const openNotifications = false
const activeNavItemIndex = null as number

export const themeUI = createSlice({
  name: 'themeUI',
  initialState: {
    openNavigation,
    openSidebar,
    openNotifications,
    activeNavItemIndex,
  },
  reducers: {
    toggleNavigation: (state) => {
      window.localStorage.setItem('openNavigation', `${!state.openNavigation}`)
      state.openNavigation = !state.openNavigation
    },
    toggleSidebar: (state) => {
      window.localStorage.setItem('openSidebar', `${!state.openSidebar}`)
      state.openSidebar = !state.openSidebar
    },
    toggleNotifications: (state) => {
      state.openNotifications = !state.openNotifications
    },
    resetNavigation: (state) => {
      state.openNavigation = true
    },
    setActiveNavItemIndex: (state, action) => {
      state.activeNavItemIndex = action.payload
    },
  },
})

export const { toggleNavigation, toggleSidebar, toggleNotifications, resetNavigation, setActiveNavItemIndex } =
  themeUI.actions

export default themeUI.reducer
